import React, { useEffect, useState } from 'react';
import useContentfulCalculators from '../contentfulCalculators'; // Corrected path
import Container from './Container';

const SavingsCalculatorComponent = () => {
    const calculators = useContentfulCalculators();
    const [filteredCalculator, setFilteredCalculator] = useState(null);
    const [result, setResult] = useState({ futureValue: 0, interestEarned: 0, totalInvested: 0 });
    const [showResults, setShowResults] = useState(false);

    useEffect(() => {
        const findSavingsCalculator = () => {
            const savingsCalculator = calculators.find(calculator => calculator.fields.title === 'Savings Calculator');
            if (savingsCalculator) {
                setFilteredCalculator(savingsCalculator);
            }
        };
        findSavingsCalculator();
    }, [calculators]);

    const calculateFinalAmount = () => {
        const periodicSavingsAmount = parseFloat(document.getElementById('periodic-savings-amount').value);
        const numberOfPeriods = parseFloat(document.getElementById('number-of-periods').value);
        const annualInterestRate = parseFloat(document.getElementById('annual-interest-rate').value);

        if (annualInterestRate > 1000) {
            alert('Annual Interest Rate should not exceed 1000.');
            return;
        }

        const r = annualInterestRate / 100 / 12; // Monthly interest rate
        const n = numberOfPeriods;
        const P = periodicSavingsAmount;

        const futureValue = P * ((Math.pow(1 + r, n) - 1) / r);
        const totalInvested = P * n;
        const interestEarned = futureValue - totalInvested;

        setResult({
            futureValue: futureValue.toFixed(2),
            interestEarned: interestEarned.toFixed(2),
            totalInvested: totalInvested.toFixed(2),
        });
        setShowResults(true);
        document.getElementById('final-amount').innerText = `$${futureValue.toFixed(2)}`;
        document.getElementById('interest-earned').innerText = `$${interestEarned.toFixed(2)}`;
        document.getElementById('total-invested').innerText = `$${totalInvested.toFixed(2)}`;
    };

    useEffect(() => {
        if (filteredCalculator) {
            const handleSubmit = (event) => {
                event.preventDefault();
                calculateFinalAmount();
            };

            const form = document.getElementById('savings-calculator-form');
            form.addEventListener('submit', handleSubmit);

            return () => {
                form.removeEventListener('submit', handleSubmit);
            };
        }
    }, [filteredCalculator]);

    if (!filteredCalculator) {
        return <div>Loading...</div>;
    }

    return (
        <Container>
            <section className="pt-24 pb-16">
                <div className="container mx-auto py-5">
                    <div className="flex justify-center mt-5">
                        <div className="w-full max-w-lg md:w-1/2 uk-mortgage">
                            <form id="savings-calculator-form">
                                <div className="mb-6">
                                    <label htmlFor="periodic-savings-amount" className="block mb-2">Periodic Savings Amount ($)</label>
                                    <div className="relative">
                                        <span className="absolute h-full px-4 inset-y-0 left-0 pl-3 flex items-center text-gray-500 bg-gray-200">$</span>
                                        <input id="periodic-savings-amount" type="number" className="form-input block w-full pl-12 pr-3 py-2 border rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" required />
                                    </div>
                                </div>
                                <div className="mb-6">
                                    <label htmlFor="number-of-periods" className="block mb-2">Number of Periods to Save</label>
                                    <input id="number-of-periods" type="number" className="form-input block w-full pl-4 pr-3 py-2 border rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" required />
                                </div>
                                <div className="mb-6">
                                    <label htmlFor="annual-interest-rate" className="block mb-2">Annual Interest Rate</label>
                                    <div className="relative">
                                        <input id="annual-interest-rate" type="number" step="0.01" max="100" className="form-input block w-full pl-4 pr-12 py-2 border rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" required />
                                        <span className="absolute h-full px-4 inset-y-0 right-0 pr-3 flex items-center text-gray-500 bg-gray-200">%</span>
                                    </div>
                                </div>
                                <button type="submit" className="block py-2 px-4 xl:px-5 xl:py-3 2xl:px-7 text-holborn-blue hover:bg-opacity-20 xl:hover:text-holborn-mid-blue tracking-wider text-sm lg:bg-holborn-green lg:text-white lg:rounded-3xl lg:hover:bg-holborn-blue xl:hover:text-white xl:transition-colors xl:duration-700 mt-4">Calculate</button>
                            </form>
                            <div id="calc-result" className="pt-8">
                                <div className="mb-2">Final Amount (future value): <span className='font-bold' id="final-amount"></span></div>
                                <div className="mb-2">Interest Earned: <span className='font-bold' id="interest-earned"></span></div>
                                <div>Total Amount Invested: <span className='font-bold' id="total-invested"></span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Container>
    );
};

export default SavingsCalculatorComponent;
